
<template>
  <div
    class="py-4 p-st"
    :class="{
      'bg-light': !nightMode,
      'bg-dark2': nightMode,
      'text-light': nightMode,
    }"
  >
    <div class="container">
      <div
        class="text-center"
        data-aos="fade"
        data-aos-once="true"
        data-aos-duration="1000"
      >
        <span
          class="title text-center"
          :class="{ pgray: !nightMode, 'text-light': nightMode }"
          >Kontakt</span
        >
      </div>
      <hr
        width="50%"
        :class="{ pgray: !nightMode, 'bg-secondary': nightMode }"
      />
      <br />

      <div class="text-center pb-4">
        <button
              :nightMode="nightMode"
              :class="{ 'btn-dark': nightMode, btn: !nightMode}"              
              @click="open('email')"
              v-tooltip.bottom="'E-Mail'"
            >
              <i class="fa-solid fa-envelope"></i>
            </button>
            <!-- <button
              class="btn btn-outline-secondary mx-2 "
              @click="open('whatsapp')"
              v-tooltip.bottom="'WhatsApp'"
            >
              <i class="fa-brands fa-whatsapp"></i>
            </button>       -->
        <button
              :class="{ 'btn-dark': nightMode, btn: !nightMode}"
              @click="open('linkedin')"
              v-tooltip.bottom="'LinkedIn'"
            >
              <i class="fab fa-linkedin"></i>
            </button>
            <button
              :class="{ 'btn-dark': nightMode, btn: !nightMode}"
              @click="open('facebook')"
              v-tooltip.bottom="'facebook'"
            >
              <i class="fab fa-facebook"></i>
            </button>
          </div>
      
          

    </div>
  </div>
</template>

<script>
import info from "../../info";

export default {
  name: "Kontakt",
  components: {
    
  },
  props: {
    nightMode: {
      type: Boolean,
    },
  },
  data() {
    return {
      linkedin: info.links.linkedin,
      facebook: info.links.facebook
    };
  },
  methods: {
    open(link) {
      switch (link) {
        case "linkedin":
          window.open(this.linkedin, "_blank");
          break;
        case "facebook":
          window.open(this.facebook, "_blank");
         break 
         case "email":
         window.open("mailto:benjamin@dasilvamoreira.de?subject=Kontakt über dasilvamoreira.de", "_blank");
         break
         case "whatsapp":
         window.open("https://web.whatsapp.com/send/?phone=%2B491607883099&text&type=phone_number&app_absent=0", "_blank");
         break
      }
    },
  },
};
</script>

<style scoped>
.title {
  font-size: 30px;
  font-weight: 500;
}
.title1 {
  font-size: 24px;
  font-weight: 400;
}

.title2 {
  font-size: 20px;
  font-weight: 400;
}

.title3 {
  font-size: 16px;
  font-weight: 400;
}

.pinput {
  font-size: 18px;
  outline: none;
  border: none;
  border-radius: 7px;
  padding: 10px;
  width: 50%;
  transition: all 1s;
  background-color: #b3b3cc;
}

.btn {
  border-color: black;
  color: #ff8713;
  width: 75px;
  height: 75px;
  font-size: 40px;
  margin: 20px 20px 20px 20px;
}

.btn:hover {
  background-color: #ff8713;
  border-color: #000000;
  color: white;
}

.btn:focus {
  background-color: #ff8713;
  border-color: #ff8713;
  color: white;
}

.btn-dark {
  border-color: white;
  color: white;
  width: 75px;
  height: 75px;
  font-size: 40px;
  margin: 20px 20px 20px 20px;
}

.btn-dark:hover {
  background-color: #ff8713;
  border-color: #000000;
  color: white;
}

.btn-dark:focus {
  background-color: #ff8713;
  border-color: #ff8713;
  color: white;
}

.pgray-dark {
  background-color: #3c4148 !important;
}

@media screen and (max-width: 1000px) {
  .pinput {
    width: 90%;
  }
  .pinput {
    width: 90%;
  }
  
}
</style>
